<!-- TODO: can we just replace this with the gallery-view -->
<div class="agent-list">
  <div class="agents">
    <app-agent-card *ngFor="let agent of agents; trackBy: Agent.trackBy" [agent]="agent" [includeTitle]="true" (onAgentEmailClicked)="onAgentEmailClicked.emit($event)"
    ></app-agent-card>
    <!-- Use this to keep items in the last row left aligned when it doesnt take the full row -->
    <div class="empty-placeholder"></div>
    <div class="empty-placeholder"></div>
    <div class="empty-placeholder"></div>
    <div class="empty-placeholder"></div>
  </div>
  <app-pagination [totalPages]="pagination.totalPages" [currentPageNumber]="pagination.pageNumber" (onChangePage)="changePage($event)"></app-pagination>
</div>
